
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import { TakipEntity } from "@/entity/TakipEntity";
import { TakipDurumu, TakipDurumuLabel } from "@/enum/TakipDurumu";
import TakipListFilterForm from "@/components/takip/form/TakipListFilterForm.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {RehberVideolari} from "@/enum/RehberVideolari";
import {VekaletEntity} from "@/entity/VekaletEntity";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import AlacakKopyalaForm from "@/components/forms/AlacakKopyalaForm.vue";
import TakipKopyalaForm from "@/components/forms/TakipKopyalaForm.vue";
import TakipSenkronize from "@/plugins/uyap-plugin/takip_ac/TakipSenkronize";
import {
  mapPttDurumToTebligatDurumu,
  normalizeDateForApi,
  resolveBilaTarihi
} from "@/components/lists/takipSyncResultHelpers";

interface Options {
  sortBy: string[];
  sortDesc: boolean[];
  page: number;
  itemsPerPage: number;
}

interface BorcluAlacakli {
  ad: string | null;
  soyad: string | null;
  kurum_adi: string | null;
}

interface UyapSyncResultItem {
  dosya_esas_no: string;
  status: string;
  message: string;
  processedCount?: number;
}

interface BarkodSyncResultItem {
  takip_id: number | string;
  mesaj: string;
}

@Component({
  components: {
    TakipKopyalaForm,
    AlacakKopyalaForm,
    FormDialog,
    TakipListFilterForm,
    DeleteDialog
  }
})
export default class TakipList extends Vue {
  @Prop({default: false}) showDetailedSearch!: boolean;
  @Prop({default: false}) muvekkilTakipList !: boolean;
  @Prop() propItems !: Array<TakipEntity>;

  items: Array<TakipEntity> = [];
  filterLineVisible = false;
  takipDurumuLabel = TakipDurumuLabel;
  checkboxesShow = false;
  confirmDialog = {
    visible: false as boolean,
    title: 'Onay' as string,
    message: '' as string,
    resolve: (choice: boolean) => {}
  };

  barkodResultDialog = false;
  barkodBasariliSonuclar: BarkodSyncResultItem[] = [];
  barkodHataliSonuclar: BarkodSyncResultItem[] = [];
  uyapResultDialog = false;
  uyapBasariliSonuclar: UyapSyncResultItem[] = [];
  uyapHataliSonuclar: UyapSyncResultItem[] = [];

  showAll = false;
  infiniteFrom = 0;
  infiniteLoading = false;
  itemsLenght = 0;
  isLoading = false;
  pageSizes = [20, 50, 100];
  options: Options = { sortBy: [] as string[], sortDesc: [] as boolean[], page: 1, itemsPerPage: 20 };
  private _mountedDone = false;
  private _infiniteObserver: IntersectionObserver | null = null;
  private _suppressOptionsWatch = false;

  allCheckbox = false;
  takipCheckbox: boolean[] = [];

  filters: any = {
    id: null,
    borcluAdSoyad: null,
    borcluTcKimlik: null,
    alacakliTcKimlik: null,
    borcluVergiKimlik: null,
    alacakliVergiKimlik: null,
    icraDairesi: null,
    dosyaEsasNo: null,
    alacakliAdSoyad: null,
    takipDurumu: null,
    ilamEsasNo: null,
    ilamKararNo: null,
    kartNo: null,
    icraProKartNo: null,
    mtsEsasNo: null,
    tuketiciKodu: null,
    kurumDosyaNo: null,
    takipTipiNo: null,
    takipEtiketi: null,
    keyword: null
  };
  oldFilters = {};
  oldOptions = {};
  sessionStorage = JSON.parse(sessionStorage.user)
  checkboxSelectionMode: string | null = null;

  headers = [
    { text: '', align: 'start', sortable: false, value: 'checkbox' },
    { text: "Kart No", sortable: true, value: "id" },
    { text: "İcra Pro Kart No", sortable: true, value: "aktar_takip_kart_no" }, // Baştan ekleyin
    { text: "Borçlu Ad Soyad", value: "borclu_ad", sortable: false },
    { text: "Alacaklı Ad Soyad", value: "alacakli_ad", sortable: false },
    { text: "Takip Tipi", value: "takip_tipi", sortable: false },
    { text: "İcra Dairesi", value: "icra_dairesi", sortable: false },
    { text: "Dosya Esas No", value: "dosya_esas_no" },
    { text: "Takip Durumu", value: "takip_durumu" },
    { text: "Takip Tarihi", value:  "takip_tarihi" },
    { text: "İşlemler", value: "actions", sortable: false, align: "end", width: 150 }
  ];

  mobileHeaders = [
    { text: '', align: 'start', sortable: false, value: 'checkbox' },
    { text: "Borçlu Ad Soyad", value: "borclu_ad", sortable: false },
    { text: "Alacaklı Ad Soyad", value: "alacakli_ad", sortable: false },
    { text: "Dosya Esas No", value: "dosya_esas_no", class: 'my-header-style' },
    { text: "Takip Tarihi", value: "takip_tarihi", class: 'my-header-style' },
    { text: "Detay", value: "actions", sortable: false, width: 150, align: "end" }
  ];
  // ---- Computed ----
  get totalPages(): number {
    if (this.showAll || this.options.itemsPerPage <= 0) return 1;
    return Math.max(1, Math.ceil(this.itemsLenght / this.options.itemsPerPage));
  }

  get pageNumbers(): (number | string)[] {
    const total = this.totalPages;
    const current = this.options.page;
    if (total <= 9) {
      const pages: number[] = [];
      for (let i = 1; i <= total; i++) pages.push(i);
      return pages;
    }
    const pages: (number | string)[] = [1];
    if (current <= 4) {
      for (let i = 2; i <= 6; i++) pages.push(i);
      pages.push('...', total);
    } else if (current >= total - 3) {
      pages.push('...');
      for (let i = total - 5; i <= total; i++) pages.push(i);
    } else {
      pages.push('...', current - 1, current, current + 1, '...', total);
    }
    return pages;
  }

  // ---- Footer actions ----
  setPageSize(size: number) {
    this.showAll = false;
    this.destroyInfiniteObserver();
    this.infiniteFrom = 0;
    this.options = { ...this.options, itemsPerPage: size, page: 1 };
  }

  setAllItems() {
    if (this.showAll) return;
    this.showAll = true;
    this.items = [];
    this.infiniteFrom = 0;
    this.itemsLenght = 0;
    this._suppressOptionsWatch = true;
    this.options = { ...this.options, page: 1, itemsPerPage: 100 };
    this.$nextTick(() => {
      this._suppressOptionsWatch = false;
      this.loadInfiniteChunk();
      this.setupInfiniteObserver();
    });
  }

  prevPage() {
    if (this.options.page > 1) {
      this.options = { ...this.options, page: this.options.page - 1 };
    }
  }

  nextPage() {
    if (this.options.page < this.totalPages) {
      this.options = { ...this.options, page: this.options.page + 1 };
    }
  }

  goToPage(p: number | string) {
    if (typeof p === 'number') {
      this.options = { ...this.options, page: p };
    }
  }

  goToFirstPage() {
    if (this.options.page > 1) {
      this.options = { ...this.options, page: 1 };
    }
  }

  goToLastPage() {
    if (this.options.page < this.totalPages) {
      this.options = { ...this.options, page: this.totalPages };
    }
  }

  setupInfiniteObserver() {
    this.destroyInfiniteObserver();
    this.$nextTick(() => {
      const sentinel = document.getElementById('infinite-scroll-sentinel');
      if (!sentinel) return;
      this._infiniteObserver = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            this.showAll &&
            !this.infiniteLoading &&
            this.items.length < this.itemsLenght
          ) {
            this.loadInfiniteChunk();
          }
        },
        { rootMargin: '300px' }
      );
      this._infiniteObserver.observe(sentinel);
    });
  }

  destroyInfiniteObserver() {
    if (this._infiniteObserver) {
      this._infiniteObserver.disconnect();
      this._infiniteObserver = null;
    }
  }

  async loadInfiniteChunk() {
    if (this.infiniteLoading || !this.showAll) return;
    if (this.infiniteFrom > 0 && this.items.length >= this.itemsLenght && this.itemsLenght > 0) return;

    this.infiniteLoading = true;
    try {
      const activeFilters = Object.entries(this.filters)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .reduce((acc: any, [key, value]) => {
          if (key === 'takipTipiNo' && typeof value === 'object' && value !== null) {
            return { ...acc, [key]: (value as any).no };
          }
          if (key === 'takipEtiketi' && typeof value === 'object' && value !== null) {
            if (Array.isArray(value)) {
              const names = (value as any[]).map((item: any) => item.id).filter(Boolean);
              return names.length > 0 ? { ...acc, [key]: names } : acc;
            }
          }
          return { ...acc, [key]: value };
        }, {});

      const keyword = this.filters.keyword?.toString().trim();
      const id = this.filters.id?.toString().trim();
      const queryParam = [keyword, id].filter(Boolean).join(' ');
      const size = 100;
      const from = this.infiniteFrom;

      let endpoint = '';
      if (queryParam) {
        endpoint = `/api/v1/takipler/search?query=${encodeURIComponent(queryParam)}&size=${size}&from=${from}`;
      } else {
        endpoint = `/api/v1/takipler?size=${size}&from=${from}`;
      }

      const payload = {
        sortBy: this.options?.sortBy || [],
        sortDesc: this.options?.sortDesc || [],
        filters: activeFilters
      };

      const response = await this.$http.post(endpoint, payload);
      const { newItems, total } = this.extractFromResponse(response);

      this.items = [...this.items, ...newItems];
      this.infiniteFrom += newItems.length;
      if (from === 0) {
        this.itemsLenght = total || newItems.length;
      }
    } catch (error) {
      console.error('Infinite scroll chunk yüklenirken hata:', error);
    } finally {
      this.infiniteLoading = false;
    }
  }

  private extractFromResponse(response: any): { newItems: TakipEntity[]; total: number } {
    if (!response || !response.data) return { newItems: [], total: 0 };

    if (Array.isArray(response.data)) {
      const newItems = response.data.map((item: any) => item._source || item);
      const total = Object.prototype.hasOwnProperty.call(response, 'total') && typeof (response as any).total === 'number'
        ? (response as any).total : newItems.length;
      return { newItems, total };
    }

    if (typeof response.data === 'object' && response.data !== null &&
        response.data.hits && Array.isArray(response.data.hits.hits)) {
      const newItems = response.data.hits.hits.map((hit: any) => hit._source || hit);
      let total = newItems.length;
      if (response.data.hits.total && typeof response.data.hits.total === 'number') {
        total = response.data.hits.total;
      } else if (response.data.hits.total && typeof response.data.hits.total.value === 'number') {
        total = response.data.hits.total.value;
      }
      return { newItems, total };
    }

    if (typeof response.data === 'object' && response.data !== null) {
      const dataArray = Object.values(response.data).find(val => Array.isArray(val)) as any[] | undefined;
      if (dataArray && dataArray.length) {
        const newItems = dataArray.map((item: any) => item._source || item);
        const total = Object.prototype.hasOwnProperty.call(response.data, 'total') && typeof response.data.total === 'number'
          ? response.data.total : dataArray.length;
        return { newItems, total };
      }
    }

    return { newItems: [], total: 0 };
  }

  loadUyapData() {
    console.log("UYAP verileri yüklenecek");
  }



  icraDairesiIsim(item: TakipEntity): string {
    // API ofis adını farklı alanlarda gönderebiliyor:
    //  - ozel_icra_dairesi_isim: aktar/serbest metin
    //  - icra_dairesi_isim: icra_dairesi_id çözülünce gelen ad (detay ekranıyla aynı alan)
    //  - icra_dairesi: string ad veya IcraDairesiEntity nesnesi (.isim)
    const icd: any = item.icra_dairesi;
    return item.ozel_icra_dairesi_isim
        || (item as any).icra_dairesi_isim
        || (icd && (typeof icd === 'string' ? icd : icd.isim))
        || '';
  }

  /**
   * Bir takip satırının seçim için uygun olup olmadığını kontrol eder.
   * Gereksinimler:
   *   - icra dairesi bilgisi (icra_dairesi veya özel_icra_dairesi_isim)
   *   - dosya esas numarası (dosya_esas_no)
   */
  isSelectable(item: TakipEntity): boolean {
    const hasIcraDairesi = Boolean(this.icraDairesiIsim(item));
    const hasDosyaEsasNo = Boolean(item.dosya_esas_no);
    return hasIcraDairesi && hasDosyaEsasNo;
  }

  toggleSelection() {
    this.checkboxesShow = !this.checkboxesShow;
    const list = this.propItems ?? this.items;

    if (this.checkboxesShow) {
      // Selectable olan öğeler için boolean değerler, olmayanlar için de boolean değerler (false)
      this.takipCheckbox = list.map(item => this.isSelectable(item) ? false : false);
    } else {
      // clear selections
      this.takipCheckbox = [];
      this.checkboxSelectionMode = null;
    }
  }
  prepareUyapSync() {
    if (!this.checkboxesShow) {
      return this.$toast.info('Lütfen önce seçim modunu açın');
    }
    const anySelected = this.takipCheckbox.some(v => v);
    const invalidSelection = this.takipCheckbox.some((v, idx) => v && !this.isSelectable((this.propItems ?? this.items ?? [])[idx]));
    if (invalidSelection) {
      return this.$toast.error('Seçilen takipler arasında zorunlu bilgileri eksik olanlar var. Lütfen sadece geçerli takipleri seçin.');
    }
    if (!anySelected) {
      return this.$toast.warning('Lütfen en az bir takip seçin');
    }
    this.checkboxSelectionMode = 'uyap';
    this.executeUyapSync();
  }
  prepareBarkodSync() {
    if (!this.checkboxesShow) {
      return this.$toast.info('Lütfen önce seçim modunu açın');
    }
    const anySelected = this.takipCheckbox.some(v => v);
    const invalidSelection = this.takipCheckbox.some((v, idx) => v && !this.isSelectable((this.propItems ?? this.items ?? [])[idx]));
    if (invalidSelection) {
      return this.$toast.error('Seçilen takipler arasında zorunlu bilgileri eksik olanlar var. Lütfen sadece geçerli takipleri seçin.');
    }
    if (!anySelected) {
      return this.$toast.warning('Lütfen en az bir takip seçin');
    }
    this.checkboxSelectionMode = 'barkod';
    this.executeBarkodSync();
  }

  openTakipListesiVideosu() {
    window.open(`https://www.youtube.com/watch?v=${RehberVideolari.takipListesi}`, "_blank");
  }

  // -- UYAP endpoint çağrısı --
  async executeUyapSync() {
    const list = this.propItems ?? this.items ?? [];
    const selected = list.filter((_, i) => this.takipCheckbox[i]);
    if (!(await this.askConfirm('Seçili takipler için UYAP tebligat senkronizasyonu yapmak istediğinize emin misiniz?', 'UYAP Senkronizasyonu'))) {
      this.checkboxesShow = false;
      this.checkboxSelectionMode = null;
      return;
    }
    if (!selected.length) {
      return this.$toast.warning('Lütfen en az bir takip seçin');
    }
    try {
      // Use TakipSenkronize plugin directly
      const ts = new TakipSenkronize();
      const payloadForPlugin = selected.map(item => ({
        dosya_esas_no: item.dosya_esas_no,
        birim_adi: this.icraDairesiIsim(item),
        takip_id: item.id
      }));
      const resultList = await ts.runQueryForSelectedItems(payloadForPlugin);
      const normalizedResults: UyapSyncResultItem[] = Array.isArray(resultList)
          ? resultList.map((result: any) => {
            const isSuccess = result?.status === "success";
            const processedCount = Number(result?.processedCount || 0);
            const fallbackMessage = isSuccess
                ? `${processedCount} adet kayıt işlendi.`
                : "Senkronizasyon sırasında hata oluştu.";
            return {
              dosya_esas_no: result?.dosya_esas_no || "-",
              status: result?.status || "error",
              processedCount,
              message: result?.message || fallbackMessage
            };
          })
          : [];

      this.uyapBasariliSonuclar = normalizedResults.filter(item => item.status === "success");
      this.uyapHataliSonuclar = normalizedResults.filter(item => item.status !== "success");
      this.uyapResultDialog = true;

      if (this.uyapHataliSonuclar.length > 0) {
        this.$toast.warning(`UYAP senkronizasyonu tamamlandı. ${this.uyapBasariliSonuclar.length} başarılı, ${this.uyapHataliSonuclar.length} hatalı.`);
      } else {
        this.$toast.success(`UYAP senkronizasyonu tamamlandı. ${this.uyapBasariliSonuclar.length} başarılı kayıt.`);
      }
    } catch (e) {
      console.error(e);
      this.$toast.error('UYAP Senkronizasyonu sırasında hata oluştu.');
    } finally {
      this.checkboxesShow = false;
      this.checkboxSelectionMode = null;
    }
  }

  // icra dairesi ve dosya esas no olmalı eğer yok seçilememeli

  async executeBarkodSync() {
    // Onay
    if (!(await this.askConfirm(
        'Seçili takipler için barkod sorgusu yapmak istediğinize emin misiniz?',
        'Barkod Sorgusu'))) {
      this.checkboxesShow = false;
      this.checkboxSelectionMode = null;
      return;
    }

    // Seçilen takip kart numaraları
    const list = this.propItems ?? this.items;
    const ids = list
        .map((item, i) => (this.takipCheckbox[i] ? item.id : null))
        .filter(Boolean) as number[];

    if (!ids.length) {
      return this.$toast.warning('Lütfen en az bir takip seçin');
    }

    try {
      // 1) Takiplere ait tebligat kayıtlarını al
      const res = await this.$http.post('/api/v1/sorgulanabilir-tebligatlar', { takip_id: ids });
      const tebligatlar = Array.isArray(res.data) ? res.data : [];

      this.barkodBasariliSonuclar = [];
      this.barkodHataliSonuclar = [];

      // 2) Her kayıt için kontrol
      for (const t of tebligatlar) {
        if (!t) continue;

        // Hatalı kayıt mı? (id yok ama takip_id ve mesaj var)
        if (!t.id && t.takip_id && t.mesaj) {
          this.barkodHataliSonuclar.push({
            takip_id: t.takip_id,
            mesaj: t.mesaj
          });
          continue;
        }

        // Başarılı kayıt için barkod sorgusu
        if (!t.id) {
          this.barkodHataliSonuclar.push({
            takip_id: t.takip_id || '-',
            mesaj: 'Geçersiz tebligat kaydı.'
          });
          continue;
        }

        const barkodNo = t.barkod_no?.toString().trim();
        if (!barkodNo) {
          this.barkodHataliSonuclar.push({
            takip_id: t.takip_id || '-',
            mesaj: 'Barkod numarası bulunamadı.'
          });
          continue;
        }

        try {
          // PTT sorgusu
          const ptt = await this.$uyap.PttBarkodSorgula().run({ barkodNo });
          if (ptt.status !== 'success') {
            this.barkodHataliSonuclar.push({
              takip_id: t.takip_id || '-',
              mesaj: ptt.message || 'PTT barkod sorgusunda hata oluştu.'
            });
            continue;
          }

          // 3) Yeni PTT cevabındaki updateData/rawData üzerinden güncellenecek alanları hazırla
          const updateData = ptt.updateData || {};
          const kabulData = ptt.rawData?.kabul;
          const normalizedGonderimTarihi =
              normalizeDateForApi(t.tebligat_gonderim_tarihi) ||
              normalizeDateForApi(updateData.tebligat_gonderim_tarihi) ||
              new Date().toISOString().split('T')[0];

          const normalizedTeslimTarihi = normalizeDateForApi(updateData.teslim_tarihi);
          const normalizedBilaTarihiFromPtt = normalizeDateForApi(updateData.bila_tarihi);
          const mappedTebligatDurumu = mapPttDurumToTebligatDurumu(updateData.tebligat_durumu, t.tebligat_durumu || 'gonderildi');
          const normalizedBilaTarihi = resolveBilaTarihi(mappedTebligatDurumu, normalizedBilaTarihiFromPtt, normalizedGonderimTarihi);
          const normalizedTebligTarihi =
              normalizeDateForApi(t.teblig_tarihi) ||
              normalizedTeslimTarihi ||
              normalizeDateForApi(ptt.rawData?.sondurum?.teslim_tarihi);
          const normalizedTeslimAlan =
              updateData.teslim_alan?.toString().trim() ||
              ptt.rawData?.sondurum?.teslim_alan?.toString().trim() ||
              ptt.rawData?.sondurum?.ahk_teslim_alan?.toString().trim() ||
              ptt.rawData?.sondurum?.sozl_teslim_alan?.toString().trim() ||
              t.teslim_alan?.toString().trim() ||
              null;
          const normalizedTebligatTeslimTipiId = Number(
              t.tebligat_teslim_tipi_id || updateData.tebligat_teslim_tipi_id || 0
          ) || (mappedTebligatDurumu === 'teblig_edildi' ? 1 : null);

          const payload: any = {
            id: t.id,
            borclu_id: t.borclu_id,
            belge_turu: t.belge_turu || t.items?.[0]?.belge_turu || '',
            takip_tipi_id: t.takip_tipi_id,
            tebligat_adres_turu: t.tebligat_adres_turu || '',
            tebligat_durumu: mappedTebligatDurumu,
            tebligat_gonderim_tarihi: normalizedGonderimTarihi,
            tebligat_sekli: t.tebligat_sekli || '',

            // opsiyonel/ekstra alanlar
            teslim_tarihi: normalizedTeslimTarihi,
            bila_sebebi: updateData.bila_sebebi || null,
            bila_tarihi: normalizedBilaTarihi,
            teblig_tarihi: normalizedTebligTarihi,
            tebligat_teslim_tipi_id: normalizedTebligatTeslimTipiId,
            teslim_alan: normalizedTeslimAlan,
            belge_no: kabulData?.barkod_no || t.belge_no || '',
            gonderim_turu: kabulData?.odeme_tipi || t.gonderim_turu || '',
            gonderim_tarihi: normalizedGonderimTarihi
          };

          // 4) Sunucuya güncelle (tebligatın id'sini kullan)
          await this.$http.put(`/api/v1/tebligat/${t.id}`, payload);
          this.barkodBasariliSonuclar.push({
            takip_id: t.takip_id || '-',
            mesaj: 'Barkod sorgulama ve tebligat güncelleme başarılı.'
          });
        } catch (itemError) {
          const responseData = (itemError as any)?.response?.data;
          const validationErrors = responseData?.errors && typeof responseData.errors === 'object'
              ? Object.values(responseData.errors)
                  .reduce((acc: string[], item: any) => acc.concat(Array.isArray(item) ? item : [item]), [])
                  .filter(Boolean)
                  .join(' ')
              : '';
          this.barkodHataliSonuclar.push({
            takip_id: t.takip_id || '-',
            mesaj: validationErrors
                || responseData?.message
                || (itemError instanceof Error ? itemError.message : 'Barkod sorgulama kaydı işlenirken hata oluştu.')
          });
        }
      }

      // Sonuçları göster
      this.barkodResultDialog = true;
      if (this.barkodHataliSonuclar.length > 0) {
        this.$toast.warning(`Barkod sorgulama tamamlandı. ${this.barkodBasariliSonuclar.length} başarılı, ${this.barkodHataliSonuclar.length} hatalı kayıt.`);
      } else {
        this.$toast.success(`Barkod sorgulama tamamlandı. ${this.barkodBasariliSonuclar.length} kayıt başarıyla güncellendi.`);
      }
    } catch (e) {
      console.error(e);
      this.$toast.error('Barkod sorgulama sırasında hata oluştu.');
    } finally {
      this.checkboxesShow = false;
      this.checkboxSelectionMode = null;
    }
  }

  askConfirm(message: string, title: string = 'Onay'): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmDialog.title = title;
      this.confirmDialog.message = message;
      this.confirmDialog.resolve = resolve;
      this.confirmDialog.visible = true;
    });
  }

  onDeleteSuccess() {
    setTimeout(() => {
      this.load();
    }, 300);
  }


  detay(item: TakipEntity) {
    let filteredTakip= localStorage.getItem('filteredTakip')
    if (filteredTakip != null) {
      let takipler = JSON.parse(filteredTakip);
      takipler.index = takipler.data.indexOf(item.id);
      localStorage.setItem('filteredTakip', JSON.stringify(takipler));
    }
    if (item.takip_durumu === TakipDurumu.acilmamis) {
      this.$router.push(ProgramPaths.icrapro + '/takip-ekle/' + item.id);
    } else {
      this.$router.push(ProgramPaths.icrapro + '/takip/' + item.id);
    }
  }
  @Watch('allCheckbox')
  AllSelectCheckbox() {
    const list = this.propItems ?? this.items ?? [];
    this.takipCheckbox = list.map(() => this.allCheckbox);
  }


  @Watch('options', { deep: true })
  optionsControl() {
    if (this._mountedDone && !this.propItems && !this._suppressOptionsWatch) {
      this.load();
    }
  }

  async load() {
    if (this.propItems) {
      this.$emit("load");
      return;
    }

    // Hepsi (infinite scroll) modundayken filtre/sıralama değişirse baştan yükle
    if (this.showAll) {
      this.destroyInfiniteObserver();
      this.infiniteFrom = 0;
      this.items = [];
      this.itemsLenght = 0;
      await this.loadInfiniteChunk();
      this.$nextTick(() => this.setupInfiniteObserver());
      return;
    }

    this.isLoading = true;
    try {
      const activeFilters = Object.entries(this.filters)
          .filter(([_, value]) => value !== null && value !== undefined && value !== '')
          .reduce((acc, [key, value]) => {
            // ekAlanlar: boş obje ise gönderme; dolu ise olduğu gibi geç
            if (key === 'ekAlanlar') {
              if (value && typeof value === 'object' && Object.keys(value).length > 0) {
                return { ...acc, [key]: value };
              }
              return acc;
            }
            if (key === 'takipTipiNo' && typeof value === 'object' && value !== null) {
              return { ...acc, [key]: value.no };
            }
            // takipEtiketi objesi ise, sadece isim field'ını kullan
            if (key === 'takipEtiketi' && typeof value === 'object' && value !== null) {
              // Eğer array ise, isim'leri al
              if (Array.isArray(value)) {
                const names = value.map(item => item.id).filter(Boolean);
                return names.length > 0 ? { ...acc, [key]: names } : acc;
              }
            }
            return { ...acc, [key]: value };
          }, {});

      const keyword = this.filters.keyword?.toString().trim();
      const id = this.filters.id?.toString().trim();
      const queryParam = [keyword, id].filter(Boolean).join(' ');
      let endpoint = '';

      const size = this.showAll ? 10000 : (this.options?.itemsPerPage ?? 20);
      const from = this.showAll ? 0 : (this.options?.page - 1) * size;

      if (queryParam) {
        endpoint = `/api/v1/takipler/search?query=${encodeURIComponent(queryParam)}&size=${size}&from=${from}`;
      } else {
        endpoint = `/api/v1/takipler?size=${size}&from=${from}`;
      }

      let payload = {
        sortBy: this.options?.sortBy || [],
        sortDesc: this.options?.sortDesc || [],
        filters: activeFilters
      }

      const response = await this.$http.post(endpoint, payload);

      if (response && response.data) {
        if (Array.isArray(response.data)) {
          this.items = response.data.map((item: any) => item._source || item);

          // Sütun gizleme/gösterme yerine direkt render et
          // Dinamik ekleme kodunu buradaki kaldırın

          if (response.hasOwnProperty('total') && typeof (response as any).total === 'number') {
            this.itemsLenght = (response as any).total;
          } else {
            this.itemsLenght = response.data.length;
          }

        }
        else if (typeof response.data === 'object' && response.data !== null &&
            response.data.hits && Array.isArray(response.data.hits.hits)) {
          this.items = response.data.hits.hits.map((hit: any) => hit._source || hit);

          if (response.data.hits.total && typeof response.data.hits.total === 'number') {
            this.itemsLenght = response.data.hits.total;
          } else if (response.data.hits.total && typeof response.data.hits.total.value === 'number') {
            this.itemsLenght = response.data.hits.total.value;
          } else {
            this.itemsLenght = this.items.length;
          }

        }
        else if (typeof response.data === 'object' && response.data !== null) {
          const dataArray = Object.values(response.data).find(val => Array.isArray(val)) as any[] | undefined;

          if (dataArray && dataArray.length) {
            this.items = dataArray.map((item: any) => item._source || item);

            if (response.data.hasOwnProperty('total') && typeof response.data.total === 'number') {
              this.itemsLenght = response.data.total;
            } else {
              this.itemsLenght = dataArray.length;
            }
          } else {
            this.items = [];
            this.itemsLenght = 0;
          }
        } else {
          this.items = [];
          this.itemsLenght = 0;
        }
      } else {
        this.items = [];
        this.itemsLenght = 0;
      }
    } catch (error) {
      console.error('Takip listesi yüklenirken hata:', error);
      this.items = [];
      this.itemsLenght = 0;
    } finally {
      this.isLoading = false;
      this.$emit("load");
    }
  }

  // async syncUyapDosya(takip: any) {
  //   let defaultClass = this.$refs['icon' + takip.uyap_dosya_id].$el.classList.value;
  //   this.$refs['icon' + takip.uyap_dosya_id].$el.classList.value += ' mdi-spin'
  //   this.$refs['icon' + takip.uyap_dosya_id].$el.style.color = 'orange'
  //   let takipData = (await this.$http.get('/api/v1/takip/filter?uyap_dosya_id=' + takip.uyap_dosya_id)).data[0];
  //   await this.$store.dispatch('senkronizeEt', takipData);
  //   this.$refs['icon' + takip.uyap_dosya_id].$el.style.color = 'green'
  //   this.$refs['icon' + takip.uyap_dosya_id].$el.classList.value = defaultClass;
  // }

  mounted() {
    if (!this.propItems) {
      this.load();
    }
    this.$nextTick(() => {
      this._mountedDone = true;
    });
  }

  beforeDestroy() {
    this.destroyInfiniteObserver();
  }
}
